import type { Customer } from "@/types"

const { VITE_STRIPE_PUBLIC_KEY, VITE_STRIPE_PUBLIC_TEST_KEY } = import.meta.env

const getCustomerStripeKey = (customer: Customer) =>
  customer.useTestStripeKey ? VITE_STRIPE_PUBLIC_TEST_KEY : VITE_STRIPE_PUBLIC_KEY

export default getCustomerStripeKey
